import { css } from 'styled-components';

/**
 * Keyboard focus indicator for the tag popovers, matching the ui-kit Button variants so a keyboard user
 * sees the same ring here as everywhere else. `:focus-visible` only, so clicking never draws it.
 */
export const focusRing = css`
  &:focus-visible {
    outline: 2px solid var(--dodger-blue);
    outline-offset: 2px;
  }
`;

/**
 * What usePopover should move focus to when a tag popover opens. Widens the hook's default (buttons
 * only) to include fields, so the panel lands on its search box / first tag checkbox rather than on
 * "Create a new tag" — where an immediate Enter would open the new-tag input.
 */
export const POPOVER_FOCUS_SELECTOR =
  'input:not([type="hidden"]), button:not([disabled]), [tabindex]:not([tabindex="-1"])';
